export default __webpack_public_path__ + "static/media/env3.aa723391.hdr";